import React, {useEffect, useState} from "react";
import zoomImg from "../../../../assets/icons/imgBtn.svg";
import BlogImagePopper from "./BlogImageLarge";
import image55a from "../../../../assets/images/Blog62/image55a.png";
import image53 from "../../../../assets/images/Blog62/image53.png";

import image6 from "../../../../assets/images/Blog62/image6.png";
import image7 from "../../../../assets/images/Blog62/image7.png";
import image42 from "../../../../assets/images/Blog62/image42.png";
import image50 from "../../../../assets/images/Blog62/image50.png";
import image101 from "../../../../assets/images/Blog62/image101.png";
import image79 from "../../../../assets/images/Blog62/image79.png";
import image23 from "../../../../assets/images/Blog62/image23.png";
import image26 from "../../../../assets/images/Blog62/image26.png";
import image10 from "../../../../assets/images/Blog62/image10.png";
import image19 from "../../../../assets/images/Blog62/image19.png";
import image21 from "../../../../assets/images/Blog62/image21.png";
import image22 from "../../../../assets/images/Blog62/image22.png";
import image12 from "../../../../assets/images/Blog62/image12.png";
import image105 from "../../../../assets/images/Blog62/image105.png";

const Blog62 = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleRedirect = (url) => {
    window.open(url, "_blank");
  };
  const handleLargeImg = (img) => {
    setSelectedImage(img);
  };
  return (
    <div className="MainNewBlog">
      <div className="blogHeader">
        <h2 className="headerBoldText mainHeader">Weekly Market Outlook – March 30th, 2026</h2>
      </div>
      <div className="blogContentnew">
        <p className="highlightedText">Geopolitical Risk Peaks, Positioning Extremes Build Beneath Weak Structure</p>
        <p>
          Markets are entering the week with a noticeably heavier tone, as risk appetite fades and participation becomes increasingly defensive. What began as cautious optimism early in the week gave
          way to late-week de-risking, with flows suggesting investors were more focused on protecting downside than chasing upside. The shift was not abrupt, but gradual — a steady erosion of
          confidence as macro uncertainty built through the week.
        </p>
        <p>
          Beneath the surface, oil and the dollar are tightening financial conditions. This tightening is subtle but impactful, feeding into pricing across assets and limiting upside follow-through.
          The result is a market that feels fragile, reactive, and highly sensitive to headlines, with positioning now leaning heavily toward caution rather than conviction.
        </p>

        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Market Overview: Risk-Off Positioning Dominates as Structure Weakens</p>
              <p>Equity markets are showing clear signs of stress, with breadth deteriorating and key technical levels either breaking or sitting on thin support.</p>
              <p>
                {" "}
                The shift in tone across the week was notable — early optimism faded into persistent selling pressure, particularly into Thursday and Friday, where positioning reflected weekend risk
                aversion rather than directional confidence. This type of price action typically reflects uncertainty rather than a strong bearish conviction.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image55a}
                    alt="4 week war stock trend by day"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image55a)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>
                The underlying structure suggests a market trading like a downtrend, where rallies are consistently sold into rather than extended. with systematic strategies and shorter-term
                participants dominating price movements. There is limited evidence of strong dip-buying flows stepping in with conviction.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image53}
                    alt="Friday capitulation"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image53)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>
                At the core of this shift is the <span className="highlightedText">macro overlay</span>, where geopolitical developments and energy markets are dictating sentiment more than
                traditional economic drivers. This has created a market environment where <span className="highlightedText">price action is being shaped externally,</span> reducing the reliability of
                typical technical signals and increasing sensitivity to news-driven moves.
              </p>
            </div>
          </div>
        </div>

        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Macro & Policy Watch: Energy Shock, Rates Pressure, and Geopolitical Constraints</p>
              <p>
                The dominant macro driver remains the ongoing geopolitical tension in the Middle East, with particular focus on critical energy transit routes and escalation risks. Developments around
                shipping restrictions and regional positioning have reinforced concerns around supply disruption, while the timeline of the conflict remains uncertain despite expectations of a
                relatively contained duration.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image6}
                    alt="red sea stress points"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image6)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image7}
                    alt="SoH no go zone"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image7)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>
                This has elevated oil’s role from a cyclical input to a core macro transmission mechanism, tightening financial conditions and feeding directly into inflation expectations. The market
                is increasingly treating energy as a constraint on policy flexibility rather than just a component of inflation.
              </p>
              <p>
                Simultaneously, bond yields have moved higher, reflecting concerns around inflation persistence and the potential policy response. The recent behaviour in rates suggests that the bond
                market is reasserting itself as the dominant force.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image42}
                    alt="US10Y approaching point of no return"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image42)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>
                Policy expectations remain conflicted, with markets balancing between inflation risks and eventual easing scenarios, increasing the likelihood of volatility across both rates and
                equities.
              </p>
            </div>
          </div>
        </div>

        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Technical & Sentiment Breakdown: Supportive, but Increasingly Fragile</p>
              <p>
                While the broader structure shows signs of weakening, <span className="highlightedText"> sentiment and positioning metrics suggest conditions are becoming stretched,</span> introducing
                the potential for instability in both directions. But the market is no longer cleanly positioned for continuation.
              </p>
              <p>
                Breadth indicators highlight the extent of the pressure, with large parts of the market trading below key moving averages. This reflects a{" "}
                <span className="highlightedText">broad-based risk-off move,</span> rather than weakness isolated to specific sectors or themes.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image50}
                    alt="SPX 200dma breadth cratering"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image50)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>
                At the same time, positioning data suggests that <span className="highlightedText">hedging activity and short exposure have increased materially,</span> indicating a market that is
                already leaning defensive. This type of positioning can limit further downside momentum unless new catalysts emerge.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image101}
                    alt="hedgies already extreme short bounce potential"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image101)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>
                Volatility has remained elevated, reinforcing the idea that uncertainty is actively being priced, not ignored. Sustained elevated volatility tends to create more abrupt moves and less
                stable trends.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image79}
                    alt="Vix elevated >25 for 4 weeks now"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image79)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>
                The combination of <span className="highlightedText">weak structure and stretched positioning </span> creates a fragile equilibrium, where even modest shifts in narrative could lead to
                <span className="highlightedText"> sharp counter-trend moves or accelerated downside,</span> depending on the catalyst.
              </p>
            </div>
          </div>
        </div>

        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Last Week’s Recap: From Early Optimism to Late-Week De-Risking</p>
              <p>
                The past week reflected a clear transition from <span className="highlightedText">initial stability to defensive positioning,</span> with macro developments gradually overriding
                underlying market resilience. The shift in tone was most visible in the latter half of the week, where flows indicated increasing caution and reduced willingness to hold risk into
                uncertainty.
              </p>
              <p className="highlightedText">Key Highlights:</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Macro: </span>
                    <br />
                    Rising input costs and energy pressures continued to build, reinforcing concerns around inflation persistence driven by supply-side constraints. These pressures are not yet fully
                    reflected in broader data but are increasingly visible in leading indicators and upstream inputs.
                  </p>
                  <div
                    className="imageWrapperCont"
                    style={{marginTop: "22px"}}
                  >
                    <div className="relatedImg">
                      <img
                        src={image23}
                        alt="polyethylene feeds ISM prices paid"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image23)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt="zoom"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">China:</span>
                    <br />
                    Energy dynamics are being viewed through the lens of broader global pricing trends, with implications for demand cycles and inflation trajectories. The interaction between energy
                    costs and domestic conditions remains a key area of focus.
                  </p>
                  <div
                    className="imageWrapperCont"
                    style={{marginTop: "22px"}}
                  >
                    <div className="relatedImg">
                      <img
                        src={image26}
                        alt="energy could confirm Japan deflation escape"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image26)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt="zoom"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Earnings:</span>
                    <br />
                    Corporate outlook remains sensitive to macro uncertainty, particularly around cost pressures and demand visibility. This is contributing to a more cautious tone, even in the
                    absence of widespread negative revisions.
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Commodities:</span>
                    <br />
                    Agricultural and input-related commodities continue to highlight upstream inflation pressures, suggesting that cost pressures may continue to feed through into broader price levels
                    over time.
                  </p>
                  <div
                    className="imageWrapperCont"
                    style={{marginTop: "22px"}}
                  >
                    <div className="relatedImg">
                      <img
                        src={image10}
                        alt="agg commods feed food prices"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image10)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt="zoom"
                          />
                        </button>
                      </div>
                    </div>
                    <div className="relatedImg">
                      <img
                        src={image19}
                        alt="Gold trend"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image19)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt="zoom"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Crypto: </span>
                    <br />
                    Digital assets remain under pressure, with extended weakness reflecting reduced speculative participation and broader risk aversion. The persistence of downside highlights the
                    absence of strong inflows.
                  </p>
                  <div
                    className="imageWrapperCont"
                    style={{marginTop: "22px"}}
                  >
                    <div className="relatedImg">
                      <img
                        src={image21}
                        alt="BTC on for joint record losing streak"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image21)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt="zoom"
                          />
                        </button>
                      </div>
                    </div>
                    <div className="relatedImg">
                      <img
                        src={image22}
                        alt="Fannie mae accepting crypto collateral"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image22)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt="zoom"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Oil:</span>
                    <br />
                    Energy markets remain central to the macro narrative, with pricing reflecting both current constraints and forward-looking risks tied to geopolitical developments. The balance
                    between supply concerns and market expectations continues to drive volatility.
                  </p>
                  <div
                    className="imageWrapperCont"
                    style={{marginTop: "22px"}}
                  >
                    <div className="relatedImg">
                      <img
                        src={image12}
                        alt="macquarie sees $200 oil"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image12)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt="zoom"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">The Week Ahead: Key Data and Market-Moving Signals</p>
              <p>
                The week is driven by a dense macro calendar alongside ongoing geopolitical developments, with a focus on central bank communication, inflation data, and labour market signals. Markets
                will be reacting through the lens of yields, oil, and positioning, with data likely reinforcing or challenging the current macro narrative.
              </p>

              <p className="highlightedText">Monday, March 30</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Germany:</span> CPI (regional and national)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">UK:</span> Credit, lending, and money supply data
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">EU:</span> Business sentiment and consumer confidence
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Dallas Fed Manufacturing Index
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> 3-month and 6-month bill auctions
                  </p>
                </li>
                <li className="themesPointer">
                  <p>Fed Chair Powell and Fed speakers</p>
                </li>
              </ul>

              <p className="highlightedText">Tuesday, March 31</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Japan:</span> CPI (Tokyo), unemployment, retail sales
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">China:</span> Manufacturing and non-manufacturing PMIs
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Australia:</span> RBA meeting minutes
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">UK:</span> GDP and housing data
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Germany:</span> Retail sales and unemployment
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">France:</span> CPI and consumer spending
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Eurozone:</span> CPI and core inflation
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> House price indices and Chicago PMI
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Consumer confidence and JOLTS job openings
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> API crude oil inventories
                  </p>
                </li>
                <li className="themesPointer">
                  <p>Fed and ECB speakers</p>
                </li>
              </ul>

              <p className="highlightedText">Wednesday, April 1</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Japan:</span> Tankan survey (business outlook)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">China:</span> Manufacturing PMI
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Europe:</span> Manufacturing PMI (France, Germany, Eurozone, UK)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> ADP Nonfarm Employment
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Retail sales and core retail sales
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> ISM Manufacturing (prices, employment, orders)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Crude oil inventories
                  </p>
                </li>
                <li className="themesPointer">
                  <p>Fed, ECB, and BoC speakers</p>
                </li>
              </ul>

              <p className="highlightedText">Thursday, April 2</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">South Korea and China:</span> CPI
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">India:</span> Manufacturing PMI
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Italy:</span> Retail sales
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Initial and continuing jobless claims
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Trade balance, exports, and imports
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Canada:</span> Trade balance
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Fed balance sheet and reserve data
                  </p>
                </li>
                <li className="themesPointer">
                  <p>ECB Economic Bulletin</p>
                </li>
              </ul>

              <p className="highlightedText">Friday, April 3</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Japan and China:</span> Services PMI
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Nonfarm Payrolls (NFP)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Unemployment rate and participation
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Average hourly earnings
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> S&P Global Services and Composite PMI
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Global:</span> Good Friday holiday (low liquidity conditions)
                  </p>
                </li>
              </ul>

              <div
                className="imageWrapperCont"
                style={{marginTop: "22px"}}
              >
                <div className="relatedImg">
                  <img
                    src={image105}
                    alt="EW300326"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image105)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Alpha Takeaway: Positioning Extreme, Macro Uncertain</p>
              <p>
                Markets are navigating a period where <span className="highlightedText">macro-driven volatility and positioning extremes are interacting in real time,</span> creating a fragile but
                reactive environment. The balance between structure and sentiment is becoming increasingly delicate.
              </p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Equities:</span>
                    <br />
                    Many markets have either broken key supports or are sitting on them, with rallies being heavily leaned on and price action reflecting a clear risk-off tone. Positioning into the
                    end of the week also suggests caution, with flows leaning defensive.
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Gold & Silver:</span>
                    <br />
                    Gold has bounced off the lower trendline, marking a classic point of potential rally or pivot, with price action sitting at a level where a move higher or rejection becomes
                    important.
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Crypto:</span>
                    <br />
                    Crypto is set for a sixth consecutive red month, matching one of its worst historical runs, highlighting persistent weakness and lack of sustained buying.
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Macro:</span>
                    <br />
                    The pace of US10Y yields is dictating market direction, while oil and the dollar are tightening financial conditions, reinforcing the pressure across assets.
                  </p>
                </li>
              </ul>
              <p className="highlightedText">
                There are optimum conditions for a counter-trend consolidation rally, with positioning stretched and markets already leaning defensive. That said, the environment remains
                headline-driven, with rates and geopolitics continuing to dictate direction. Trade carefully.
              </p>
              <div
                className="imageWrapperCont"
                style={{marginTop: "22px"}}
              >
                <div className="relatedImg">
                  <img
                    src={image101}
                    alt="hedgies already extreme short bounce potential"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image101)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image50}
                    alt="SPX 200dma breadth cratering"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image50)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>

              <div
                className="imageWrapperCont"
                style={{marginTop: "22px"}}
              >
                <div className="relatedImg">
                  <img
                    src={image79}
                    alt="Vix elevated >25 for 4 weeks now"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image79)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="button_wrapper">
          <button
            className="gradientButton_small "
            onClick={() => {
              handleRedirect("https://docs.google.com/document/d/1-Ic1t5DllzVm8oUqiWbVBl8z9sgna0RV-v-Puwiajl8/edit?usp=drive_link");
            }}
          >
            Read In-Depth Market Outlook
          </button>
        </div>
      </div>
      {selectedImage && (
        <BlogImagePopper
          image={selectedImage}
          onClose={() => handleLargeImg(null)}
        />
      )}
    </div>
  );
};

export default Blog62;
